var motionComponentSymbol=Symbol["for"]("motionComponentSymbol");export{motionComponentSymbol};